import styled from 'styled-components';

export const Button = styled.button`
  width: auto;
  min-width: ${(props) => props.width || '0'}px;
  height: ${(props) => (props.variant === 'link' ? 'auto !important' : '35px !important')};
  min-height: ${(props) => (props.variant === 'link' ? 'auto' : '35px')};

  background-color: ${(props) =>
    props.variant === 'link'
      ? 'transparent'
      : props.disabled
        ? 'var(--grey-5, #F2F2F3)'
        : props.primary
          ? 'var(--blue-50)'
          : props.disabled
            ? 'var(--grey-2)'
            : 'var(--grey-5, #F2F2F3)'};

  color: ${(props) =>
    props.disabled
      ? 'var(--grey-20, #C9CBCF)'
      : props.primary
        ? '#FFFFFF'
        : 'var(--blue-50, #0095FF)'} !important;

  border: none;
  padding: ${(props) => (props.variant === 'link' ? 'unset' : '8px 16px')};
  margin-top: ${(props) => props.marginTop || '0'}px;
  border-radius: ${(props) => (props.variant === 'link' ? '0' : '10px')};
  text-align: center;
  display: flex;
  text-transform: none !important;
  align-items: center;
  justify-content: center;
  margin-right: ${(props) => (props.myCreator ? '' : '10px')};
  font-family: 'Montserrat Medium';

  &:hover {
    background-color: ${(props) =>
      props.variant === 'link'
        ? 'transparent'
        : props.disabled
          ? 'var(--grey-5, #F2F2F3)'
          : props.primary
            ? 'var(--blue-60)'
            : 'var(--grey-10, #E4E5E7)'};

    /* border: none; */
  }

  cursor: ${(props) => (props.disabled ? 'not-allowed !important' : 'pointer')};

  @media (max-width: 425px) {
    width: auto;
  }
`;
